import React, { Component } from 'react'
import { CodeableConcepts, Coding, Period, Hospitalization } from '../helpers'
import { LuFolderCheck, LuFolderX } from 'react-icons/lu'
import { FaPeopleRoof, FaCalendarDays, FaBookMedical } from 'react-icons/fa6'
import { BsHospital } from 'react-icons/bs'

import './resource.css'

class EncounterBig extends Component {

    render() {
        return (
            <div className="Resource-Container-Patient">
                <div className='Res-Flex-Spread'>
                    <div style={{ marginRight: '5px' }}>
                        <div className={`Res-Icon ${this.props.resource.active ? 'Res-Icon-Active' : 'Res-Icon-Inactive'}`}>{this.props.resource.active ? <LuFolderCheck /> : <LuFolderX />}</div>
                        <div className='Res-Icon-Label'>{this.props.resource.active ? 'Active' : "Inactive"}</div>
                    </div>
                    <div className='Res-Icon-Big'><FaPeopleRoof /></div>
                    <div className='Res-Title'>
                        {this.props.resource.class && <div><div className='Res-Detail'>{Coding(this.props.resource.class)}</div><div className='Res-Icon-Label'>Class</div></div>}
                    </div>
                </div>
                {this.props.resource.type && <div className='Res-Row Res-Title'>{CodeableConcepts(this.props.resource.type)}</div>}
                <div className='Res-Row Res-Flex-Spread'>
                    <div>{this.props.resource.period && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaCalendarDays /></div><div className='Res-Detail'>{Period(this.props.resource.period)}</div></div>}</div>
                    <div>{this.props.resource.reasonCode && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaBookMedical /></div><div className='Res-Detail'>{CodeableConcepts(this.props.resource.reasonCode)}</div></div>}</div>
                </div>
                {this.props.resource.hospitalization && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><BsHospital /></div><div className='Res-Detail'>{Hospitalization(this.props.resource.hospitalization)}</div></div>}
            </div>
        )
    }
}

export default EncounterBig